import _ from 'lodash'
import { computed, ref } from 'vue'

export default function createGame(deck) {
  const newPlayer = ref(true)

  const startGame = () => {
    newPlayer.value = false

    restartGame()
  }

  const restartGame = () => {
    deck.value = _.shuffle(deck.value)

    deck.value = deck.value.map((card, index) => {
      return {
        ...card,
        matched: false,
        position: index,
        visible: false
      }
    })
  }

  const status = computed(() => {
    
    if (matchesFound.value === 8) {
      var var1 = "✌ 👏 كفو كفو ";
      var var2 = "<br><br>";
      var var3 = "<img src='https://i.giphy.com/media/WkuENfwxILywyGPY0D/giphy.webp' border='0'>";
      return `${var1}  ${var2}  ${var3}`
    // } else if (matchesFound.value === 1) { 
    //   var smiley1 = "🧐";
    //   var textPlyer1 = " بداية الطريق خطوة ";
    //   var globalVariable1 = "مراقبين تحركاتك يالحبيب";
    //   return `${globalVariable1} :  ${matchesFound.value}  ${textPlyer1} ${smiley1}`
    // } else if (matchesFound.value === 4) { 
    //   var smiley4 = "🧐";
    //   var textPlyer4 = " ممتاز قطعت نص المشوار ";
    //   var globalVariable4 = "مراقبين تحركاتك يالحبيب";
    //   return `${globalVariable4} :  ${matchesFound.value}  ${textPlyer4} ${smiley4}`  
    } else {
      var smiley = "🧐";
      var globalVariable = "مراقبين تحركاتك يالحبيب";
      return `${globalVariable} :  ${matchesFound.value}  ${smiley}`
    }
  })

  const matchesFound = computed(() => {
    const matchedCards = deck.value.filter(card => card.matched === true).length

    return matchedCards / 2
  })

  return {
    matchesFound,
    newPlayer,
    restartGame,
    startGame,
    status
  }
}
